import { useSelector } from 'react-redux';
import { Router } from '@vst/beam-icons/icons';
import { useTranslation } from 'react-i18next';

import { selectNetwork } from '@app/redux';

import { OntMode } from '@mfe/shared/schema-types';

import { NetworkManagementCard } from './network-management-card';

type OntModeCardProps = {
  ontMode: OntMode | null;
  onErrorClick: (e: React.MouseEvent<HTMLElement>) => void;
  onSwitchToBridgeModeClick: (e: React.MouseEvent<HTMLElement>) => void;
  onSwitchToWifiModeClick: (e: React.MouseEvent<HTMLElement>) => void;
};

export const OntModeCard = ({
  ontMode,
  onErrorClick,
  onSwitchToBridgeModeClick,
  onSwitchToWifiModeClick,
}: OntModeCardProps) => {
  const { t } = useTranslation('Network');

  const { ontModeError } = useSelector(selectNetwork);
  const hasError = Boolean(ontModeError);

  if (hasError) {
    return (
      <NetworkManagementCard
        icon={Router}
        title={t('networkManagement.currentModeUnavailable')}
        buttonLabel={t('networkManagement.tryAgain')}
        onClick={onErrorClick}
      />
    );
  }

  if (ontMode === OntMode.WiFi) {
    return (
      <NetworkManagementCard
        icon={Router}
        title={t('networkManagement.wifiMode')}
        buttonLabel={t('networkManagement.switchToBridgeMode')}
        onClick={onSwitchToBridgeModeClick}
      />
    );
  }

  if (ontMode === OntMode.Bridge) {
    return (
      <NetworkManagementCard
        icon={Router}
        title={t('networkManagement.bridgeMode')}
        buttonLabel={t('networkManagement.switchToWifiMode')}
        onClick={onSwitchToWifiModeClick}
      />
    );
  }

  return null;
};
